// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__SwyoE","buttons":"Footer_buttons__3zMTg"};